import { Image } from "react-native";

export default function Title({ source, resizeMode='contain', style = {} }) {

  return (<Image style={{height: 77, width: '100%', maxWidth: 325,  marginTop: 30,...style}} resizeMode={resizeMode} width={320} source={source}/>);
}
